import dayJs from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime'
import {toDouble} from '@/utils/utils';
dayJs.extend(relativeTime)

/**
 * 功能：将时间戳按照给定的 时间/日期 格式进行处理
 * @param {Number} date 时间戳
 * @returns {String} 规范后的 时间/日期 字符串
 */
 export function formatDateDay(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('YYYY-MM-DD'); // 使用 dayJs 格式化时间
}
export function formatDate(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('YYYY-MM-DD HH:mm'); // 使用 dayJs 格式化时间
}

export function formatDateHourMinute(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('HH:mm'); // 使用 dayJs 格式化时间
}

export function formatDateHourStr(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    let hours =  dayJs(date).format('HH'); // 使用 dayJs 格式化时间
    let nextHours = parseInt(hours)+1;
    return toDouble(parseInt(hours))+":00"+"~"+toDouble(nextHours)+":00";
}

export function formatWeekday(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('YYYY-MM-DD dddd'); // 使用 dayJs 格式化时间
}

export function formatJustWeekday(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('dddd'); // 使用 dayJs 格式化时间
}

export function formatDateWeekday(date: any) {
    dayJs.locale('zh-cn')
    if (!date) {
        return '---';
    }
    return dayJs(date).format('YYYY-MM-DD HH:mm dddd'); // 使用 dayJs 格式化时间
}

export function fmtTime(date: any) {
    dayJs.locale('zh-cn')
    if (dayJs().diff(dayJs(date), 'minutes') > 0.5) {
        return dayJs(date).fromNow()
    }
    return "刚刚" // 使用 dayJs 格式化时间
}

